import { render, staticRenderFns } from "./CustomerCoordForm.vue?vue&type=template&id=a7242f12"
import script from "./CustomerCoordForm.vue?vue&type=script&lang=js"
export * from "./CustomerCoordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports